import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "CircleExclamation",
  [
    [
      "path",
      {
        d: "M12 1.5 a10.5 10.5 0 1 1 0 21 a10.5 10.5 0 1 1 0 -21 z m0 22.5 A12 12 0 1 0 12 0 a12 12 0 1 0 0 24 z m0 -18 c-0.4125 0 -0.75 0.3375 -0.75 0.75 l0 6 c0 0.4125 0.3375 0.75 0.75 0.75 s0.75 -0.3375 0.75 -0.75 l0 -6 c0 -0.4125 -0.3375 -0.75 -0.75 -0.75 z m1.125 10.5 a1.125 1.125 0 1 0 -2.25 0 a1.125 1.125 0 1 0 2.25 0 z",
      },
    ],
  ],
  "currentColor"
);
